import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import './login.css';

import { basicMsg } from '../../helpers/swal_msg';

//MUI
import {
    Button, Box, Container, Typography
} from '@mui/material'
import { styled } from '@mui/material/styles';

import { GOOGLE_DRIVE_CDN } from '../../constants/constants';

const ColorButton = styled(Button)(({ theme }) => ({
    color: '#fff',
    backgroundColor: '#283A49',
    textTransform: 'none',
    width: '100%',
    height: '50px',
    '&:hover': {
        backgroundColor: '#374a5a',
    },
}));

const Login = () => {
    // mensaje
    const { msg } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (msg && msg !== '') {
            if (msg === 'site-err')
                basicMsg('Intente iniciar de nuevo');
            else if (['ax-err', 'server-err'].includes(msg))
                basicMsg('Incidente en el servidor');
            navigate('/', { replace: true });
        }
    }, [msg]);

    const handleSubmit = (e) => {
        e.preventDefault();
        // window.location.href = `${process.env.REACT_APP_OAUTH_AUTHORIZATION_ENDPOINT}?client_id=${process.env.REACT_APP_MICROSOFT_APP_ID}&scope=User.Read&response_type=code`;

        const url = `${process.env.REACT_APP_OAUTH_AUTHORIZATION_ENDPOINT}?` +
            `client_id=${process.env.REACT_APP_MICROSOFT_APP_ID}` +
            `&response_type=code` +
            `&scope=User.Read` +
            `&redirect_uri=${encodeURIComponent(process.env.REACT_APP_REDIRECT_URI)}`;

        window.location.href = url;
    };

    return (
        <div className='bg_login'>
            <Container maxWidth='lg' sx={{ py: 10, pb: 8 }}>
                <div className='form_login'>

                    <Typography variant='h5' sx={{ fontWeight: 'bold' }} gutterBottom>
                        Iniciar sesión
                    </Typography>
                    <ColorButton variant='contained' onClick={handleSubmit}>
                        Acceder con cuenta de Microsoft
                    </ColorButton>
                    <Box sx={{ mt: 3 }}>
                        <img src={ `${GOOGLE_DRIVE_CDN}1HjvKS-tfQ1pOWNtIFM04tZB005zxAkUl` }
                        alt="logo-think-beyond" width='100%' style={{ pointerEvents: 'none' }} />
                    </Box>
                </div>
            </Container>
        </div>
    );
};

export default Login;